<template>
  <div id="dashboard">
    <nav-menu></nav-menu>
    <configuracoes-dashboard ref="frConfiguracoes" @carregarDados="carregarDadosDaConfiguracao"></configuracoes-dashboard>

    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <div id="principal">
        <div 
          class="w3-col s12 m12 l12 w3-margin-bottom"
          style="padding: 0" 
          v-show="!informacoes_paineis && !carregando_configuracoes">

          <div class="w3-panel w3-theme w3-card-2">
            <p>
              <i class="fa fa-exclamation-triangle"></i>
              Para obter os dados do dashboard, é necessário realizar a configuração dos parâmetros. 
              <label @click="$refs.frConfiguracoes.abrirModal()">
                <strong>CLIQUE AQUI</strong>
              </label>
              para configurá-los
            </p>
          </div>
        </div>
        

        <div 
          class="w3-col s12 m12 l12 w3-margin-bottom" 
          v-show="carregando_configuracoes"
          style="padding: 0">
        
          <div class="w3-panel w3-theme w3-card-2">
            <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
          </div>
        </div>

        <div 
          class="w3-row-padding w3-margin-bottom w3-col s12" 
          v-cloak 
          v-if="informacoes_paineis">
          
          <swiper ref="awesomeSwiperA" :options="configuracoes_swiper">
            <swiper-slide v-if="!informacoes_paineis.vendas_vazio">
              <div class="w3-block w3-row-padding w3-text-theme w3-col" style="padding: 5px; margin: 6px 0;">
                <h3 class="w3-col l6 m6 s6"><i class="fa fa-shopping-cart"></i> Vendas</h3>
                <h3 class="w3-col l6 m6 s6 w3-right-align" @click="$refs.frConfiguracoes.abrirModal">
                  <i class="fa fa-cog"></i>
                </h3>
              </div>
              
              <div class="w3-block w3-container" style="padding: 0">
                <div 
                  v-if="card_selecionado"
                  @click="atualizarCardSelecionado('')" 
                  style="margin-bottom: 5px;">
                  <button 
                    class="w3-btn w3-round-xlarge w3-gray"
                    style="color: white !important;">
                    <i class="fas fa-chevron-left"></i> 
                    Voltar
                  </button>
                </div>

                <div
                  v-show="(
                    informacoes_paineis.vendas.pedidos_ultimo_dia &&
                    (autorizacoes.painel_vendas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('pedidos_diario')"
                  @click="atualizarCardSelecionado('pedidos_diario')"
                  style="cursor: pointer; min-width: 25px">

                  <div class="card-dashboard-inner">
                    <span class="card-dashboard-titulo card-clicavel-titulo" style="font-size: 16px;">Pedidos de hoje</span>
                    <span>
                      <div style="padding: 15px;">
                        <button 
                          title="Recarregar dados"
                          class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                          v-on:click.stop="buscarVendasDiaSemanaMes('VH')">
                          <i class="fa fa-sync-alt"></i>
                        </button>
                      </div>
                    </span>

                    <div class="container-pedidos">
                      <span class="card-pedidos">
                        Vendas 
                        <strong 
                          v-if="!vendas_dia_total.carregando"
                          style="float:right"
                          class="card-dashboard-dado card-pedidos">
                          R$ {{vendas_dia_total.vendas_liquidas}}
                        </strong>
                        <i class="w3-spin fa fa-spinner" v-if="vendas_dia_total.carregando"></i>
                      </span>
                      
                      <br>
                        
                      <span class="card-pedidos">
                        Lucro líquido 
                        <strong v-if="!vendas_dia_total.carregando"
                        style="float:right"
                        class="card-dashboard-dado card-pedidos">
                        {{vendas_dia_total.perc_lucro}}%
                        </strong>
                        <i class="w3-spin fa fa-spinner" v-if="vendas_dia_total.carregando"></i>
                      </span>
                      
                      <br>
                        
                      <span class="card-pedidos">
                        Ticket médio
                        <strong 
                          v-if="!vendas_dia_total.carregando"
                          style="float:right"
                          class="card-dashboard-dado card-pedidos">
                          R$ {{vendas_dia_total.ticket_medio}}
                        </strong>
                        <i class="w3-spin fa fa-spinner" v-if="vendas_dia_total.carregando"></i>
                      </span>
                      
                      <br>
                    
                    </div>
                      
                    <div class="w3-clear"></div>
                      
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->
                  
                <div
                  v-show="(
                    informacoes_paineis.vendas.pedidos_ultimo_mes &&
                    (autorizacoes.painel_vendas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  @click.once="buscarVendasDiaSemanaMes('VS')">
                    
                  <div 
                    :class="buscarClasseCard('pedidos_semanal')" 
                    v-show="(
                      informacoes_paineis.vendas.pedidos_ultima_semana && 
                      (autorizacoes.painel_vendas == 'S' || autorizacoes.usuario_gerente == 'S')
                    )"
                    @click="atualizarCardSelecionado('pedidos_semanal')"
                    style="cursor: pointer;">

                    <div class="card-dashboard-inner">
                      <span class="card-dashboard-titulo card-clicavel-titulo" style="font-size: 16px;">Pedidos da última semana</span>

                      <span>
                        <div style="padding: 15px;">
                          <button
                            title="Recarregar dados" 
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="vendas_semana_total.ativado"
                            v-on:click.stop="buscarVendasDiaSemanaMes('VS')">
                            <i class="fa fa-sync-alt"></i>
                          </button>
                          
                          <button 
                            title="Recarregar dados" 
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="!vendas_semana_total.ativado"
                            v-on:click.stop="buscarVendasDiaSemanaMes('VS')">
                            <i class="fas fa-dollar-sign"></i>
                          </button>
                        </div>
                      </span>

                      <div v-if="!vendas_semana_total.ativado">
                        
                        <br>
                        
                        <span style="text-align:center" class="card-pedidos">
                          <span 
                            v-if="!vendas_semana_total.carregando" 
                            class="alert-card-atualizacao">
                            Informações ocultadas.<br>
                            Ative-as no botão acima.
                          </span>
                        </span>

                        <br>

                      </div>
                      
                      <div class="container-pedidos" v-else>
                        <span class="card-pedidos">
                          Vendas 
                          <span
                            v-if="!vendas_semana_total.carregando"
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos"> 
                            R$ {{vendas_semana_total.vendas_liquidas}}
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_semana_total.carregando"></i>
                        </span>
                        
                        <br>
                        
                        <span class="card-pedidos">
                          Lucro líquido 
                          <span 
                            v-if="!vendas_semana_total.carregando"
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos">
                            {{vendas_semana_total.perc_lucro}}%
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_semana_total.carregando"></i>
                        </span>
                        
                        <br>
                        
                        <span class="card-pedidos">
                          Ticket médio
                          <span 
                            v-if="!vendas_semana_total.carregando" 
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos">
                            R$ {{vendas_semana_total.ticket_medio}}
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_semana_total.carregando"></i>
                        </span>
                        
                        <br>

                      </div>
                      
                      <div class="w3-clear"></div>
                      
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div>
                
                <div
                  v-show="(
                    informacoes_paineis.vendas.pedidos_ultimo_mes && 
                    (autorizacoes.painel_vendas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  @click.once="buscarVendasDiaSemanaMes('VM')">
                  
                  <div
                    :class="buscarClasseCard('pedidos_mensal')" 
                    v-show="(
                      informacoes_paineis.vendas.pedidos_ultimo_mes && 
                      (autorizacoes.painel_vendas == 'S' || autorizacoes.usuario_gerente == 'S')
                    )"
                    @click="atualizarCardSelecionado('pedidos_mensal')"
                    style="cursor: pointer;">

                    <div class="card-dashboard-inner">
                      <span class="card-dashboard-titulo card-clicavel-titulo" style="font-size: 16px;">Pedidos do último mês</span>
                      <span>
                        <div style="padding: 15px;">
                          <button 
                            title="Recarregar dados"
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="vendas_mes_total.ativado" 
                            v-on:click.stop="buscarVendasDiaSemanaMes('VM')">
                            <i class="fa fa-sync-alt"></i>
                          </button>
                          
                          <button 
                            title="Recarregar dados" 
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="!vendas_mes_total.ativado"
                            v-on:click.stop="buscarVendasDiaSemanaMes('VM')">
                            <i class="fas fa-dollar-sign"></i>
                          </button>
                        </div>
                      </span>
                      
                      <div v-if="!vendas_mes_total.ativado">
                        <br>
                        <span class="card-pedidos">
                          <span
                            v-if="!vendas_mes_total.carregando"
                            class="alert-card-atualizacao">
                            Informações ocultadas.<br> Ative-as no botão acima.
                          </span>
                        </span><br>
                      </div>

                      <div v-else class="container-pedidos">
                        <span class="card-pedidos">
                          Vendas 
                          <span 
                            v-if="!vendas_mes_total.carregando" 
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos">
                            R$ {{vendas_mes_total.vendas_liquidas}}
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_mes_total.carregando"></i>
                        </span><br>
                        
                        <span class="card-pedidos">
                          Lucro líquido 
                          <span 
                            v-if="!vendas_mes_total.carregando" 
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos">
                            {{vendas_mes_total.perc_lucro}}%
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_mes_total.carregando"></i>
                        </span><br>
                        
                        <span class="card-pedidos">
                          Ticket médio 
                          <span
                            v-if="!vendas_mes_total.carregando"
                            style="float:right" 
                            class="card-dashboard-dado card-pedidos">
                            R$ {{vendas_mes_total.ticket_medio}}
                          </span>
                          <i class="w3-spin fa fa-spinner" v-if="vendas_mes_total.carregando"></i>
                        </span><br>
                        
                      </div>
                      
                      <div class="w3-clear"></div>
                      
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div>

                <div 
                  v-show="(
                    informacoes_paineis.vendas.pedidos_bloqueados && 
                    (autorizacoes.pedidos_bloqueados == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('pedidos_bloqueados')"
                  @click="atualizarCardSelecionado('pedidos_bloqueados')"
                  style="cursor: pointer;">
                  
                  <div class="card-dashboard-inner">
                    <span class="icone-card">
                      <i class="fa fa-times"></i>
                    </span>
                    
                    <span class="card-dashboard-titulo card-clicavel-titulo" style="font-size: 16px;">Pedidos bloqueados</span>
                    <div class="w3-right-align">
                      <span class="card-dashboard-dado">{{buscarQuantidadeInformacoesVendas("1001") }}
                        <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                      </span>
                    </div>
                    
                    <div class="w3-clear"></div>
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->
                
                <div
                  v-show="(
                    informacoes_paineis.vendas.vendas_perdida && 
                    (autorizacoes.pedidos_vencendo == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('pedidos_vencendo')"
                  @click="atualizarCardSelecionado('pedidos_vencendo')"
                  style="cursor: pointer;">
                  
                  <div class="card-dashboard-inner">
                    <span class="icone-card">
                      <i class="fa fa-exclamation-circle"></i>
                    </span>

                    <span class="card-dashboard-titulo card-clicavel-titulo">Vendas perdidas</span>
                    <div class="w3-right-align">
                      <div class="w3-left-align">
                        <span class="card-pedidos card-dashboard-dado">
                          <i class="fas fa-cog"  @click="$refs.frConfiguracoes.abrirModal"></i>
                          {{informacoes_paineis.vendas.quantidade_dias}} Dias
                        </span><br>
                      </div>
                    </div>

                    <div class="w3-clear"></div>
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->

                <div 
                  v-show="(
                    informacoes_paineis.vendas.produtos_em_promocao &&
                    (autorizacoes.produtos_em_promocao == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('produtos_em_promocao')"
                  @click="atualizarCardSelecionado('produtos_em_promocao')"
                  style="cursor: pointer;">
                  <div class="card-dashboard-inner">

                    <span class="icone-card w3-center">
                      <i class="fa fa-bolt"></i>
                    </span>

                    <span class="card-dashboard-titulo card-clicavel-titulo">Produtos em promoção</span>                    
                    <div class="w3-right-align">
                      <span class="card-dashboard-dado">{{buscarQuantidadeInformacoesVendas("1006")}}
                        <i 
                          class="w3-spin fa fa-spinner" 
                          v-if="processando_informacoes || processando_produtos_empresa">
                        </i>
                      </span>
                    </div>

                    <div class="w3-clear"></div>
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->

                <div 
                  v-show="(
                    informacoes_paineis.vendas.produtos_ponta_estoque && 
                    (autorizacoes.produto_ponta_estoque == 'S' || autorizacoes.usuario_gerente == 'S')
                  )" 
                  :class="buscarClasseCard('produtos_em_ponta_de_estoque')" 
                  @click="atualizarCardSelecionado('produtos_em_ponta_de_estoque')"
                  style="cursor: pointer;">
                  
                  <div class="card-dashboard-inner">
                    <span class="icone-card">
                      <i class="fa fa-tag"></i>
                    </span>
                    
                    <span class="card-dashboard-titulo card-clicavel-titulo">Produtos em ponta de estoque</span>
                    <div class="w3-right-align">
                      <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesVendas("1007") }}
                        <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                      </span>
                    </div>
                    <div class="w3-clear"></div>
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->

                <div 
                  v-show="(
                    informacoes_paineis.vendas.produtos_cadastrados_ultimos_30_dias &&
                    (autorizacoes.produto_cadastrado_30_dias == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('produtos_30dias')"
                  @click="atualizarCardSelecionado('produtos_30dias')"
                  style="cursor: pointer;">
                  <div class="card-dashboard-inner">

                    <span class="icone-card">
                      <i class="far fa-calendar-alt"></i>
                    </span>

                    <span class="card-dashboard-titulo card-clicavel-titulo">Produtos cadastrados nos últimos 30 dias</span>
                    <div class="w3-right-align">
                      <span class="card-dashboard-dado">{{buscarQuantidadeInformacoesVendas("1008")}}
                        <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                      </span>
                    </div>
                    
                    <div class="w3-clear"></div>

                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->

                <div
                  v-show="(
                    informacoes_paineis.vendas.produtos_comissao_especial &&
                    (autorizacoes.produto_comissao_especial == 'S' || autorizacoes.usuario_gerente == 'S')
                  )"
                  :class="buscarClasseCard('produtos_comissao_especial')" 
                  @click="atualizarCardSelecionado('produtos_comissao_especial')"
                  style="cursor: pointer;">
                  
                  <div class="card-dashboard-inner">
                    
                    <span class="icone-card">
                      <i class="far fa-handshake"></i>
                    </span>

                    <span class="card-dashboard-titulo card-clicavel-titulo">Produtos em comissão especial</span>
                    <span 
                      class="card-dashboard-titulo card-clicavel-titulo w3-small"
                      style="text-decoration: none">
                      {{ nome_empresa_comissao }}
                    </span>
                    
                    <div class="w3-right-align">
                      <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesVendas("1009") }}
                        <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                      </span>
                    </div>

                    <div class="w3-clear"></div>
                  </div><!-- card-dashboard-inner -->
                </div><!-- card-dashboard -->
                
                <div class="w3-container">
                  <componente-card
                    v-show="cardEstaSelecionado('pedidos_bloqueados')"
                    @fecharComponente="fecharComponente" 
                    icone="times" 
                    titulo-componente-card="Pedidos bloqueados">
                    
                    <pedidos-bloqueados ref="lista_pedidos_bloqueados"></pedidos-bloqueados>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('pedidos_vencendo')"
                    titulo-componente-card="Pedidos vencendo"
                    @fecharComponente="fecharComponente" 
                    icone="exclamation-circle">
                    <pedidos-vencendo :quantidade_dias="informacoes_paineis.vendas.quantidade_dias"></pedidos-vencendo>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('produtos_em_promocao')" 
                    titulo-componente-card="Produtos em promoção"
                    @fecharComponente="fecharComponente" 
                    icone="bolt">
                    <produtos-em-promocao ref="cardProdutosEmPromocao" @quantidade_produto_promocao="quantidadeProdutoPromocao"></produtos-em-promocao>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('produtos_30dias')"
                    titulo-componente-card="Produtos cadastrados nos últimos 30 dias" 
                    @fecharComponente="fecharComponente" 
                    icone="calendar-alt">
                    <produtos-cadastrados-30-dias ref="cardProdutosCadastrado30Dias" @quantidade_produto_cadastrado_30_dias="quantidadeProdutoCadastro30Dias"></produtos-cadastrados-30-dias>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('produtos_comissao_especial')"
                    titulo-componente-card="Produtos cadastrados nos últimos 30 dias"
                    @fecharComponente="fecharComponente"
                    icone="handshake">
                    <produtos-comissao-especial ref="cardProdutosComissaoEspecial" @quantidade_produto_comissao_especial="quantidadeProdutoComissaoEspecial"></produtos-comissao-especial>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('pedidos_diario')"
                    titulo-componente-card="Pedidos de hoje" 
                    @fecharComponente="fecharComponente"
                    icone="handshake">
                    <vendas-dia-semana-mes :periodo="'VH'"></vendas-dia-semana-mes>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('pedidos_semanal')"
                    titulo-componente-card="Pedidos semanal"
                    @fecharComponente="fecharComponente"
                    icone="handshake">
                    <vendas-dia-semana-mes :periodo="'VS'"></vendas-dia-semana-mes>
                  </componente-card>

                  <componente-card
                    v-if="cardEstaSelecionado('pedidos_mensal')"
                    titulo-componente-card="Pedidos mensal"
                    @fecharComponente="fecharComponente"
                    icone="handshake">
                    <vendas-dia-semana-mes :periodo="'VM'"></vendas-dia-semana-mes>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('produtos_em_ponta_de_estoque')"
                    titulo-componente-card="Produtos em ponta de estoque"
                    @fecharComponente="fecharComponente"
                    icone="handshake">
                    <produtos-ponta-estoque ref="cardProdutosPontaEstoque" @quantidade_produto_ponta_estoque="quantidadeProdutoPontaEstoque"></produtos-ponta-estoque>
                  </componente-card>
                </div>

              </div>
            </swiper-slide>

            <swiper-slide v-if="!informacoes_paineis.compras_entradas_vazio">
              <div class="w3-block w3-row-padding w3-text-theme w3-col" style="padding: 5px; margin: 6px 0;">
                <h3  class="w3-col l8 m8 s8"><i class="fas fa-dollar-sign"></i> Compras e Entradas</h3>
                <h3 class="w3-col l4 m4 s4 w3-right-align" @click="$refs.frConfiguracoes.abrirModal">
                  <i class="fa fa-cog"></i>
                </h3>
              </div>
              
              <div class="w3-block w3-container" style="padding: 0">
                <div 
                  v-if="card_selecionado" 
                  @click="atualizarCardSelecionado('')"
                  style="margin-bottom: 5px;">
                  <button 
                    class="w3-btn w3-round-xlarge w3-gray" 
                    style="color: white !important;">
                    <i class="fas fa-chevron-left"></i> 
                    Voltar
                  </button>
                </div>

                <div 
                  class="grupo-componente compras-bloqueadas" 
                  v-show="(
                    informacoes_paineis.compras_entradas.pedidos_compra_bloqueados && 
                    (autorizacoes.compras_bloqueadas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCard('compras_bloqueadas')" 
                    @click="atualizarCardSelecionado('compras_bloqueadas')" 
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="far fa-hand-paper"></i>
                      </span>

                      <span class="card-dashboard-titulo card-clicavel-titulo">Pedidos de compra bloqueados</span>
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.001") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- compras-bloqueadas -->

                <div 
                  class="grupo-componente compras-pendentes-sem-restricoes" 
                  v-show="(
                    informacoes_paineis.compras_entradas.pedidos_compra_pendentes_sem_restricao && 
                    (autorizacoes.compras_pendentes_sem_restricao == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div
                    :class="buscarClasseCard('compras_pendentes_sem_restricoes')" 
                    @click="atualizarCardSelecionado('compras_pendentes_sem_restricoes')"
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-shopping-cart"></i>
                      </span>

                      <span class="card-dashboard-titulo card-clicavel-titulo">Compras em aberto</span>
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.002") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- compras-pendentes-sem-restricoes -->

                <div 
                  class="grupo-componente compras-pendentes-sem-numero-fornecedor"
                  v-show="(
                    informacoes_paineis.compras_entradas.pedidos_compra_pendentes_sem_nr_fornecedor && 
                    (autorizacoes.pedidos_sem_numero_fornecedor == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCard('compras_pendentes_sem_numero_fornecedor')" 
                    @click="atualizarCardSelecionado('compras_pendentes_sem_numero_fornecedor')" 
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-exclamation-triangle"></i>
                      </span>

                      <span 
                        class="card-dashboard-titulo card-clicavel-titulo">
                        Pedidos de compra pendentes sem número do fornecedor
                      </span>
                      
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.003") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- compras-pendentes-sem-numero-fornecedor -->

                <div 
                class="grupo-componente entradas-sem-estoque-consolidado" 
                v-show="(
                  informacoes_paineis.compras_entradas.entradas_sem_estoque_consolidado && 
                  (autorizacoes.entrada_sem_estoque_consolidado == 'S' || autorizacoes.usuario_gerente == 'S')
                )">
                
                  <div 
                    :class="buscarClasseCard('entradas_sem_estoque_consolidado')" 
                    @click="atualizarCardSelecionado('entradas_sem_estoque_consolidado')" 
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-project-diagram"></i>
                      </span>

                      <span class="card-dashboard-titulo card-clicavel-titulo">Entradas sem estoque consolidado</span>
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.004") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- entradas-sem-estoque-consolidado -->

                <div 
                  class="grupo-componente entradas-sem-financeiro-consolidado"
                  v-show="(
                    informacoes_paineis.compras_entradas.entradas_sem_financeiro_consolidado && 
                    (autorizacoes.entrada_sem_financeiro_consolidado == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCard('entradas_sem_financeiro_consolidado')" 
                    @click="atualizarCardSelecionado('entradas_sem_financeiro_consolidado')" 
                    style="cursor: pointer;">

                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-dollar-sign"></i>
                      </span>

                      <span class="card-dashboard-titulo card-clicavel-titulo">Entradas sem financeiro consolidado</span>
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.005") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- entradas-sem-financeiro-consolidado -->


                <div 
                  class="grupo-componente analise-de-xml" 
                  v-show="(
                    informacoes_paineis.compras_entradas.xml_pendentes &&
                    (autorizacoes.xml_pendentes_cinco_dias == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCardXml('analise-de-xml')" 
                    @click="atualizarCardSelecionado('analise-de-xml')" 
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-calendar-alt"></i>
                      </span>

                      <span class="card-dashboard-titulo card-clicavel-titulo">Análise de XML</span>
                      <div class="w3-right-align">
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- xml-pendentes-5dias -->

                <div 
                  class="grupo-componente entradas-bloqueadas" 
                  v-show="(
                    informacoes_paineis.compras_entradas.entradas_bloqueadas && 
                    (autorizacoes.entradas_bloqueada == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div
                    :class="buscarClasseCard('entradas_bloqueadas')"
                    @click="atualizarCardSelecionado('entradas_bloqueadas')"
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-hand-paper"></i>
                      </span>
                      
                      <span class="card-dashboard-titulo card-clicavel-titulo">Entradas bloqueadas</span>
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.007") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- entradas-bloqueadas -->

                <div 
                  class="grupo-componente notas-devolucoes-compras-pendentes"
                  v-show="(
                    informacoes_paineis.compras_entradas.notas_devolucoes_compras_pendentes && 
                    (autorizacoes.notas_devolucoes_compras_pendentes == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div
                    :class="buscarClasseCard('notas_devolucoes_compras_pendentes')"
                    @click="atualizarCardSelecionado('notas_devolucoes_compras_pendentes')" 
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span class="icone-card">
                        <i class="fas fa-exchange-alt"></i>
                      </span>

                      <span
                        class="card-dashboard-titulo card-clicavel-titulo"
                        >Devoluções de compras pendentes 
                        <small>(não geraram crédito a receber do fornecedor)</small>
                      </span>
                      
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ buscarQuantidadeInformacoesComprasEntradas("2.008") }}
                          <i class="w3-spin fa fa-spinner" v-if="processando_informacoes"></i>
                        </span>
                      </div>
                      
                      <div class="w3-clear"></div>
                    </div><!-- card-dashboard-inner -->
                  </div><!-- card-dashboard -->
                </div><!-- devolucoes-financeiro-sem-consolidado -->

                <main>
                  <componente-card 
                    v-if="cardEstaSelecionado('compras_bloqueadas')" 
                    titulo-componente-card="Pedidos de compra bloqueados"
                    @fecharComponente="fecharComponente">
                    <compras-bloqueadas 
                      :empresas-ids="empresas_autorizadas_id" 
                      v-on:liberarRecusarCompra="recarregarInformacoes()">
                    </compras-bloqueadas>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('compras_pendentes_sem_restricoes')"
                    titulo-componente-card="Pedidos de compra pendentes e sem restrição"
                    @fecharComponente="fecharComponente">
                    <compras-em-aberto 
                      :gerente="autorizacoes.usuario_gerente" 
                      :autorizacao_deletar="autorizacoes.cancelar_pedido_compra"
                      v-on:liberarRecusarCompra="recarregarInformacoes()">
                    </compras-em-aberto>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('compras_pendentes_sem_numero_fornecedor')"
                    titulo-componente-card="Pedidos de compra pendentes sem número do fornecedor"
                    @fecharComponente="fecharComponente">
                    <compras-pendentes-sem-nr-fornecedor
                      :gerente="autorizacoes.usuario_gerente" 
                      :autorizacao_deletar="autorizacoes.cancelar_pedido_compra">
                    </compras-pendentes-sem-nr-fornecedor>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('entradas_sem_estoque_consolidado')" 
                    titulo-componente-card="Entradas sem estoque consolidado"
                    @fecharComponente="fecharComponente">
                    <entradas-sem-estoque-consolidado/>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('entradas_sem_financeiro_consolidado')" 
                    titulo-componente-card="Entradas sem financeiro consolidado" 
                    @fecharComponente="fecharComponente" >
                    <entradas-sem-financeiro-consolidado/>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('analise-de-xml')" 
                    titulo-componente-card="Análise de XML"
                    @fecharComponente="fecharComponente">
                    <analise-de-xml @abrirModalXmlEntradasDias="abrirModalXmlEntradasDias"></analise-de-xml>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('entradas_bloqueadas')" 
                    titulo-componente-card="Entradas bloqueadas"
                    @fecharComponente="fecharComponente">
                    
                    <entradas-bloqueadas 
                      :empresas-ids="empresas_autorizadas_id"
                      v-on:liberarRecusarEntrada="recarregarInformacoes()">
                    </entradas-bloqueadas>

                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('notas_devolucoes_compras_pendentes')" 
                    titulo-componente-card="Notas de dev. compras pendentes" 
                    @fecharComponente="fecharComponente">
                    <notas-devolucoes-compras-pendentes/>
                  </componente-card>

                </main>
              </div>
            </swiper-slide>
            
            <swiper-slide 
              v-if="!informacoes_paineis.contabilidade_vazio && autorizacoes.status_contabilidade != 'I'">
              
              <div class="w3-block w3-row-padding w3-text-theme w3-col" style="padding: 5px; margin: 6px 0;">
                <h3 class=" w3-col l8 m8 s8"><i class="fas fa-calculator"></i> Contabilidade </h3>
                <h3 class="w3-col l4 m4 s4 w3-right-align" @click="$refs.frConfiguracoes.abrirModal">
                  <i class="fa fa-cog"></i>
                </h3>
              </div>

              <div class="w3-block w3-container" style="padding: 0">
                <div 
                  v-if="card_selecionado"
                  @click="atualizarCardSelecionado('')" 
                  style="margin-bottom: 5px;">
                  <button 
                    class="w3-btn w3-round-xlarge w3-gray" 
                    style="color: white !important;">
                    <i class="fas fa-chevron-left"></i> 
                    Voltar
                  </button>
                </div>
                
                <div 
                  class="grupo-componente contas-contabeis-regras-provisionamento" 
                  v-show="(
                    informacoes_paineis.contabilidade.contas_contabeis_regras_provisionamento && 
                    (autorizacoes.contas_contabeis_criticas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCard('contas_contabeis_regras_provisionamento')" 
                    @click="contas_fora_regra_provisao_carregando == 0 &&
                    atualizarCardSelecionado('contas_contabeis_regras_provisionamento')"
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo"
                        v-if="contas_fora_regra_provisao_carregando < 0"
                        @click="buscarContasContabeisRegraProvisionamento(true)">
                        Contas contábeis com divergências na regra de provisionamento
                      </span>
                      
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo" 
                        v-if="contas_fora_regra_provisao_carregando == 0">
                        Contas contábeis com divergências na regra de provisionamento
                      </span>
                      
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo" 
                        v-if="contas_fora_regra_provisao_carregando == 1">
                        Carregando
                      </span>
                      
                      <span>
                        <div style="padding: 15px;">
                          <button 
                            title="Recarregar dados" 
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="contas_fora_regra_provisao_carregando < 0" 
                            @click="buscarContasContabeisRegraProvisionamento(true)">
                            <i class="fas fa-sync-alt"></i>
                          </button>
                          
                          <button 
                            title="Recarregar dados"
                            style="margin-bottom: 25px;"
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos" 
                            v-if="contas_fora_regra_provisao_carregando == 0">
                            <i class="fas fa-tasks"></i>
                          </button>
                          
                          <button 
                            title="Recarregar dados" 
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="contas_fora_regra_provisao_carregando == 1">
                            <i class="fas fa-sync-alt w3-spin"></i>
                          </button>
                        </div>
                      </span>
                      
                      <span 
                        style="text-align:center" 
                        class="card-pedidos" 
                        v-if="contas_fora_regra_provisao_carregando < 0">
                        <span class=" alert-card-atualizacao" >
                          Para carregar as informações, clique no botão ou no título
                        </span>
                      </span>
                      
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{ quantidadade_contas_contabeis_regra_provisionamento }}
                          <i class="w3-spin fa fa-spinner" v-if="contas_fora_regra_provisao_carregando == 1"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div 
                  class="grupo-componente contas-contabeis-saldo-diferente-natureza" 
                  v-show="(
                    informacoes_paineis.contabilidade.contas_contabeis_saldo_diferente_natureza && 
                    (autorizacoes.contas_contabeis_criticas == 'S' || autorizacoes.usuario_gerente == 'S')
                  )">
                  
                  <div 
                    :class="buscarClasseCard('contas_contabeis_saldo_diferente_natureza')" 
                    @click="contas_saldo_dif_natureza_carregando == 0 &&
                    atualizarCardSelecionado('contas_contabeis_saldo_diferente_natureza')"
                    style="cursor: pointer;">
                    
                    <div class="card-dashboard-inner">
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo"
                        v-if="contas_saldo_dif_natureza_carregando < 0"
                        @click="buscarContasContabeisSaldoDiferenteNatureza(true)">
                        Contas contábeis com saldo diferente da natureza (operação não permitida)
                      </span>
                      
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo" 
                        v-if="contas_saldo_dif_natureza_carregando == 0">
                        Contas contábeis com saldo diferente da natureza (operação não permitida)
                      </span>
                      
                      <span 
                        class="card-dashboard-titulo titulo-pedidos card-clicavel-titulo"
                        v-if="contas_saldo_dif_natureza_carregando == 1">
                        Carregando
                      </span>
                      
                      <span>
                        <div style="padding: 15px;">
                          <button 
                            title="Recarregar dados"
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos" 
                            v-if="contas_saldo_dif_natureza_carregando < 0"
                            @click="buscarContasContabeisSaldoDiferenteNatureza(true)" >
                            <i class="fas fa-sync-alt"></i>
                          </button>
                          
                          <button
                            title="Recarregar dados"
                            style="margin-bottom: 25px;"
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos" 
                            v-if="contas_saldo_dif_natureza_carregando == 0">
                            <i class="fas fa-tasks"></i>
                          </button>
                          
                          <button 
                            title="Recarregar dados"
                            class="w3-button w3-theme w3-circle w3-display-bottomleft atualizar-button-pedidos"
                            v-if="contas_saldo_dif_natureza_carregando == 1">
                            <i class="fas fa-sync-alt w3-spin"></i>
                          </button>
                        </div>
                      </span>

                      <span
                        style="text-align:center"
                        class="card-pedidos"
                        v-if="contas_saldo_dif_natureza_carregando < 0">
                        <span class=" alert-card-atualizacao">Para carregar as informações, clique no botão ou no título</span>
                      </span>
                      
                      <div class="w3-right-align">
                        <span class="card-dashboard-dado">{{quantidadade_contas_contabeis_saldo_diferente_natureza}}
                          <i class="w3-spin fa fa-spinner" v-if="contas_saldo_dif_natureza_carregando == 1"></i>
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                
                <main>
                  <componente-card 
                    v-if="cardEstaSelecionado('contas_contabeis_regras_provisionamento')" 
                    titulo-componente-card="Contas contábeis com divergências na regra de provisionamento" 
                    @fecharComponente="fecharComponente">
                    
                    <contas-contabeis-regras-provisionamento 
                      :contas_contabeis="fora_regra_provisao" 
                      :contas_fora_regra_provisao_carregando="contas_fora_regra_provisao_carregando">
                    </contas-contabeis-regras-provisionamento>
                  </componente-card>

                  <componente-card 
                    v-if="cardEstaSelecionado('contas_contabeis_saldo_diferente_natureza')" 
                    titulo-componente-card="Contas contábeis com saldo diferente da natureza" 
                    @fecharComponente="fecharComponente">

                    <contas-contabeis-saldo-diferente-natureza 
                      :contas_contabeis="saldo_dif_natureza" 
                      :contas_saldo_dif_natureza_carregando="contas_saldo_dif_natureza_carregando">
                    </contas-contabeis-saldo-diferente-natureza>
                  </componente-card>
                </main>

              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <button 
        id="floating-button" 
        title="Recarregar dados"
        v-on:click="recarregarInformacoes()"
        class="w3-button w3-theme w3-display-bottomright">
        <i class="fa fa-sync-alt"/>
      </button>
    </div>

    <modal-mix 
      :mix="mix" 
      v-if="mostrarModalMix" 
      @close="mostrarModalMix = false">
    </modal-mix>
    
    <modal-xml-entradas-dias 
      :xml="xml" :listaXml="listaXml"
      v-if="mostrarDiasModalXmlEntradas"
      @close="mostrarDiasModalXmlEntradas = false">
    </modal-xml-entradas-dias>

  </div>
</template>

<script>
  import moment from 'moment'
  import store from '@/ambiente/store';
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'

  /* PADRÃO */
  import NavMenu from '@/components/Menu'
  import ComponenteCard from '@/components/ComponenteCard'

  /* VENDAS */
  import ProdutosPontaEstoque from '@/components/Dashboard/ProdutosPontaEstoque'
  import PedidosBloqueados from '@/components/PedidosBloqueados'
  import ProdutosEmPromocao from '@/components/Dashboard/ProdutosEmPromocao'
  import ProdutosCadastrados30Dias from '@/components/Dashboard/ProdutosCadastrados30Dias'
  import ProdutosComissaoEspecial from '@/components/Dashboard/ProdutosComissaoEspecial'
  import PedidosVencendo from '@/components/Dashboard/PedidosVencendo'
  import VendasDiaSemanaMes from '@/components/Dashboard/VendasDiaSemanaMes'
  import ModalMix from '@/components/ModalMix'
  import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
  import LiberarPedidosBloqueados from '@/components/LiberarPedidosBloqueados'


  /* COMPRAS E ENTRADAS */
  import ComprasBloqueadas from '@/components/Dashboard/ComprasBloqueadas'
  import ComprasEmAberto from '@/components/Dashboard/ComprasEmAberto'
  import EntradasSemEstoqueConsolidado from '@/components/Dashboard/EntradasSemEstoqueConsolidado'
  import EntradasSemFinanceiroConsolidado from '@/components/Dashboard/EntradasSemFinanceiroConsolidado'
  import ComprasPendentesSemNrFornecedor from '@/components/Dashboard/ComprasPendentesSemNrFornecedor'
  
  import AnaliseDeXml from '@/components/Dashboard/AnaliseDeXml'
  import EntradasBloqueadas from '@/components/Dashboard/EntradasBloqueadas'
  import ModalXmlEntradasDias from '@/components/Dashboard/ModalXmlEntradasDias'
  
  import NotasDevolucoesComprasPendentes from '@/components/Dashboard/NotasDevolucoesComprasPendentes'

  /* CONTABILIDADE */
  import ContasContabeisRegrasProvisionamento from '@/components/Dashboard/ContasContabeisRegrasProvisionamento'
  import ContasContabeisSaldoDiferenteNatureza from '@/components/Dashboard/ContasContabeisSaldoDiferenteNatureza'
  
  /*rests*/
  import REntrada from '@/components/Rest/REntrada.js'
  import ROrcamentoBuscarDadosOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosOrcamento.js'
  import RContaContabil from '@/components/Rest/RContaContabil.js'
  import ROrcamentoBuscarVendasDashboard from '@/components/Rest/ROrcamento/ROrcamentoBuscarVendasDashboard.js'
  import RSessao from '@/components/Rest/RSessao.js'
  import ROrcamentoBuscarVendasDiaSemanaMesDashboard from '@/components/Rest/ROrcamento/ROrcamentoBuscarVendasDiaSemanaMesDashboard.js'
  
  
  /* SWIPER */
  import 'swiper/dist/css/swiper.css'
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import toastr from 'toastr'
  import ConfiguracoesDashboard from '@/components/ConfiguracoesDashboard'

  export default {
    name: 'Dashboard',
    components: {
      ModalXmlEntradasDias,
      NavMenu,
      swiper,
      swiperSlide,
      ComponenteCard,
      PedidosBloqueados,
      LiberarPedidosBloqueados,
      ProdutosEmPromocao,
      ProdutosCadastrados30Dias,
      ProdutosComissaoEspecial,
      PedidosVencendo,
      ComprasBloqueadas,
      ComprasEmAberto,
      EntradasSemEstoqueConsolidado,
      EntradasSemFinanceiroConsolidado,
      ComprasPendentesSemNrFornecedor,
      AnaliseDeXml,
      ModalMix,
      DadosOrcamento,
      EntradasBloqueadas,
      moment,
      VendasDiaSemanaMes,
      ProdutosPontaEstoque,
      NotasDevolucoesComprasPendentes,
      ContasContabeisRegrasProvisionamento,
      ContasContabeisSaldoDiferenteNatureza,
      ConfiguracoesDashboard
      
    },
    mixins:[formatarValorMixin],
    data() {
      const self = this;
      return {
        api: process.env.API,
        mapa_financeiro_dados: [],
        analitico_modelo_dois: {},
        informacoes: [],
        xml: '',
        listaXml: [],
        pedidos_bloqueados: [],
        pedidos_bloqueados_filtrados: [],
        empresas: {},
        informacoes_painel_vendas: {},
        informacoes_vendas: {},
        dados_mapa_financeiro: [],
        tab_selecionada: 'analitico',
        informacoes_compras_entradas: {},
        empresas_autorizadas_id: [],
        empresas_autorizadas: [],
        usuario_logado: '',
        nome_empresa_comissao: '',
        nome_empresa_promocao: '',
        autorizacoes: null,
        mix: {},
        mostrarDiasModalXmlEntradas: false,
        mostrarModalDadosOrcamento: false,
        mostrarModalMix: false,
        quantidade_produto_promocao: {},
        configurar: false,

        vendas_mes_total: {
          'perc_lucro':'',
          'vendas_liquidas':'',
          'ticket_medio': '',
          'carregando': false
        },

        vendas_semana_total: {
          'perc_lucro':'',
          'vendas_liquidas':'',
          'ticket_medio': '',
          'carregando': false
        },

        vendas_dia_total: {
          'perc_lucro':'',
          'vendas_liquidas':'',
          'ticket_medio': '',
          'carregando': false
        },

        informacoes_paineis: null,
        
        saldos_caixas_bancos: [
          "conta_caixa",
          "contas_bancarias"
        ],

        realizado_inicio_relatorio: [
          "receber_realizado",
          "cheques_pagar",
          "pagar_duplicata_cheque_abertos",
          "dbc_pagar_vencidos"
        ],

        parametros_financeiro_configurados: {},
        carregando_configuracoes: true,
        card_selecionado: '',
        card_selecionado_ativo: '',
        processando_informacoes: false,
        processando_painel_financeiro: false,
        processando_produtos_empresa: false,

        contas_fora_regra_provisao_carregando: -1,
        contas_saldo_dif_natureza_carregando: -1,
        quantidadade_contas_contabeis_regra_provisionamento: '',
        quantidadade_contas_contabeis_saldo_diferente_natureza: '',
        fora_regra_provisao: [],
        saldo_dif_natureza: [],

        saldos_mapa_financeiro: {},

        configuracoes_swiper: {
          noSwiping: true,
          noSwipingSelector: 'main',
          spaceBetween: 30,
          setWrapperSize: true,
          roundLengths: true,
          
          on: {
            slideChange() {
              let numeroDaPagina = this.realIndex + 1
              self.atualizarCardSelecionado('');
              window.scrollTo(0, 0);
            }
          },

          paginacao_swiper: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
            hide: true,
            renderBullet(index, className) {
              var icone = '';
              if (index === 0) {
                icone = 'fa fa-shopping-cart';
              }
              else if (index === 1) {
                icone = 'fas fa-dollar-sign'
              }
              else {
                icone ='fa fa-credit-card';
              }

              return `<span class="${className} swiper-pagination-bullet-custom"><i class="${icone}"></i></span>`;
            }
          }
        },
      }
    },

    watch: {
      mostrarModalMix() {
        const el = document.documentElement;
        if (this.verificarModalAberto) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      },

      mostrarModalDadosOrcamento() {
        const el = document.documentElement;
        if (this.verificarModalAberto) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      },

      mostrarDiasModalXmlEntradas() {
        const el = document.documentElement;
        if (this.verificarModalAberto) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      }
    },

    computed: {
      verificarModalAberto() {
        if (this.mostrarModalMix || this.mostrarDiasModalXmlEntradas || this.mostrarModalDadosOrcamento) {
          return true;
        }
        else {
          return false;
        }
      },

      existeCardsSaldos() {
        let cards_financeiro = this.informacoes_paineis.financeiro.visibilidade;
        let conta_caixa = cards_financeiro.conta_caixa;
        let contas_bancarias = cards_financeiro.contas_bancarias;

        if(conta_caixa || contas_bancarias) {
          return true;
        } 
        else {
          return false;
        }
      },

      existeCardsRealizadoInicioRelatorio() {
        let cards_financeiro = this.informacoes_paineis.financeiro.visibilidade;

        let receber_realizado = cards_financeiro.receber_realizado;
        let cheques_pagar = cards_financeiro.cheques_pagar;
        let pagar_duplicata_cheque_abertos = cards_financeiro.pagar_duplicata_cheque_abertos;
        let dbc_pagar_vencidos = cards_financeiro.dbc_pagar_vencidos;

        if(receber_realizado || cheques_pagar || pagar_duplicata_cheque_abertos || dbc_pagar_vencidos) {
          return true;
        } 
        else {
          return false;
        }
      },
      
      existeCardsPrevisoesInicioRelatorio() {
        let cards_financeiro = this.informacoes_paineis.financeiro.visibilidade;

        let pagar_previsoes = cards_financeiro.pagar_previsoes;
        let receber_previsoes = cards_financeiro.receber_previsoes;

        if(pagar_previsoes || receber_previsoes) {
          return true;
        } else {
          return false;
        }
      },

      existeCardsTitulosReceber() {
        let cards_financeiro = this.informacoes_paineis.financeiro.visibilidade;

        let tres_dias = cards_financeiro.tres_dias;
        let quinze_dias = cards_financeiro.quinze_dias;
        let trinta_dias = cards_financeiro.trinta_dias;
        let sessenta_dias = cards_financeiro.sessenta_dias;
        let noventa_dias = cards_financeiro.noventa_dias;

        if (tres_dias || quinze_dias || trinta_dias || sessenta_dias || noventa_dias) {
          return true;
        } else {
          return false;
        }
      },

      existePrevisoesVencidas() {
        let cards_financeiro = this.informacoes_paineis.financeiro.visibilidade;
        let a_pagar = cards_financeiro.previsoes_pagar_vencidas;
        if(a_pagar) {
          return true;
        } else {
          return false;
        }
      },
    },

    async created() {
      await this.buscarUsuarioLogado();
      await this.buscarAutorizacoes();
      await this.buscarEmpresasAutorizadas();
      await this.buscarInformacoesVendas();
      await this.buscarInformacoesComprasEntradas();
    },
    
    mounted() {
      this.$root.$on('recarregarInformacoes', data => {
        this.recarregarInformacoes(false);
      })
    },

    methods: {
      async carregarDadosDaConfiguracao(){
        await this.buscarUsuarioLogado();
        await this.buscarAutorizacoes();
        await this.buscarEmpresasAutorizadas();
        await this.recarregarInformacoes(true);
      },

      async buscarPedidosBloqueados() {
        let empresas_ids = [];

        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          empresas_ids.push(this.empresas_autorizadas[i].empresa_id);
        }

        await this.$refs.lista_pedidos_bloqueados.definirEmpresasIds(empresas_ids);
      },
      
      async abrirModalDadosOrcamento(orcamento_id) {
        try {
          let retorno =  await ROrcamentoBuscarDadosOrcamento.buscarDadosOrcamento(
            this.axios, 
            JSON.stringify({orcamento_id: orcamento_id})
          );
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          let dados = retorno.data.dados;
          this.orcamento_detalhe = dados;
          this.mostrarModalDadosOrcamento = !this.mostrarModalDadosOrcamento;
        } 
        catch (error) {
          console.log(error);
          toastr.error('Não foi possivel requisitar o orçamento!');
        }
      },

      abrirModalXmlEntradasDias(lista, dias) {
        this.listaXml = lista;
        this.xml = dias;
        this.mostrarDiasModalXmlEntradas = !this.mostrarDiasModalXmlEntradas;
      },

      abrirModalMix(mix) {
        this.mix = mix;
        this.mostrarModalMix = !this.mostrarModalMix;
      },

      formatarData(data) {
        return moment(data).locale('pt-br').format('L');
      },

      mostrarModal(idModal) {
        document.getElementById(idModal).style.display = 'block';
      },

      buscarClasseDados(dado) {
        if(dado) {
          if(dado.length > 12) {
            return 'card-dashboard-dado texto-reduzido';
          } else {
            return 'card-dashboard-dado';
          }
        }
      },

      mudarAbaMapaFinanceiro(modelo) {
        this.tab_selecionada = modelo;

        var x = document.getElementsByClassName("mapa-financeiro-modelo");
        for (var i = 0; i < x.length; i++) {
          x[i].style.display = "none";
        }

        document.getElementById(modelo).style.display = "block";
      },

      buscarClasseTab(tab) {
        if(this.tab_selecionada === tab) {
          return 'w3-third tablink w3-theme w3-text-white w3-padding';
        } else {
          return 'w3-third tablink w3-padding w3-hover-light-grey';
        }
      },

      retornaValoresUnicos(valor, index, self) {
        return self.indexOf(valor) == index;
      },

      atualizarCardSelecionado(card) {
        // Voltando quantidades da empresa logada
        if (this.card_selecionado == 'produtos_em_promocao'){
          this.$refs.cardProdutosEmPromocao.buscarQuantidadeTotalProdutosEmPromocao();
        } else if (this.card_selecionado == 'produtos_em_ponta_de_estoque'){
          this.$refs.cardProdutosPontaEstoque.buscarQuantidadeTotalProdutosPontaEstoque();
        } else if (this.card_selecionado == 'produtos_comissao_especial'){
          this.$refs.cardProdutosComissaoEspecial.buscarQuantidadeTotalProdutosComissaoEspecial();
        } else if (this.card_selecionado == 'produtos_30dias'){
          this.$refs.cardProdutosCadastrado30Dias.buscarQuantidadeTotalProdutosCadastrados30Dias();
        }

        // Alterando visualização do card
        this.card_selecionado = card;
        
        // Atualizando pedidos bloqueados
        if (card == 'pedidos_bloqueados') {
          this.buscarPedidosBloqueados();
        }
      },

      cardEstaSelecionado(card) {
        return this.card_selecionado === card;
      },

      buscarClasseCard(card) {
        if (this.cardEstaSelecionado(card)) {
          return 'card-dashboard card-dashboard-ativo w3-theme';
        }
        else if (this.card_selecionado != '') {
          return 'card-dashboard-escondido';
        }
        else {
          return 'card-dashboard';
        }
      },

      buscarClasseCardXml(card) {
        if (this.cardEstaSelecionado(card)) {
          return 'card-dashboard-escondido';
        }
        else if (this.card_selecionado != '')  {
          return 'card-dashboard-escondido';
        }
        else {
          return 'card-dashboard';
        }
      },

      fecharComponente() {
        event.preventDefault();
        this.card_selecionado = '';
      },

      atualizarMesmoValorCardSelecionado() {
        this.card_selecionado = this.card_selecionado_ativo;
      },

      async recarregarInformacoes() {
        await this.buscarInformacoesVendas();
        await this.buscarInformacoesComprasEntradas();

        if 
          (
            (
              (this.autorizacoes.usuario_gerente == 'S') ||
              (this.autorizacoes.contas_contabeis_criticas == 'S')
            ) &&
            (this.informacoes_paineis.contabilidade.contas_contabeis_regras_provisionamento)
          )
        {
          await this.buscarContasContabeisRegraProvisionamento(false);
        }

        if 
          (
            (
              (this.autorizacoes.usuario_gerente == 'S') ||
              (this.autorizacoes.contas_contabeis_criticas == 'S')
            ) &&
            (this.informacoes_paineis.contabilidade.contas_contabeis_saldo_diferente_natureza)
          )
        {
          await this.buscarContasContabeisSaldoDiferenteNatureza(false);
        }

        if 
          (
            this.vendas_semana_total.ativado && 
            this.informacoes_paineis.vendas.pedidos_ultima_semana && 
            (this.autorizacoes.painel_vendas == 'S' || 
            this.autorizacoes.usuario_gerente == 'S')
          ) 
        {
          await this.buscarVendasDiaSemanaMes('VS');
        }

        if 
          (
            this.vendas_mes_total.ativado && 
            this.informacoes_paineis.vendas.pedidos_ultimo_mes && 
            (this.autorizacoes.painel_vendas == 'S' ||
            this.autorizacoes.usuario_gerente == 'S')
          ) 
        {
          await this.buscarVendasDiaSemanaMes('VM');
        }

        if 
          (
            (this.informacoes_paineis.vendas) &&
            (this.informacoes_paineis.vendas.pedidos_ultimo_dia) && 
            (this.autorizacoes.painel_vendas == 'S' || this.autorizacoes.usuario_gerente == 'S')
          ) 
        {
          await this.buscarVendasDiaSemanaMes('VH');
        }

        this.card_selecionado_ativo = this.card_selecionado;
        this.card_selecionado = '';

        setTimeout(this.atualizarMesmoValorCardSelecionado, .5);
      },

      async buscarInformacoesVendas() {
        try {
          if (!this.informacoes_paineis || this.informacoes_paineis.vendas_vazio){
            return;
          }

          this.processando_informacoes = true;

          let retorno  = await ROrcamentoBuscarVendasDashboard.buscarVendasDashboard(this.axios);
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando_informacoes = false;
          this.informacoes_vendas = retorno.dados.informacoes;
        } 
        catch (error) {
          console.log(error);
          return;
        }
      },

      async buscarAutorizacoes() {
        try {
          let retorno = await RSessao.buscarAutorizacoesDashboard(this.axios);
          this.autorizacoes = retorno.dados.autorizacoes_painel['0'];
          
          await this.buscarInformacoes();
        }
        catch (error) {
          console.log(error);
          return;
        }
      },

      async buscarUsuarioLogado() {
        if (!await RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }
      
        this.usuario_logado = await JSON.parse(JSON.stringify(store.state.usuario_logado));
        this.nome_empresa = await store.state.empresa_logada.empresa_id + ' - ' + store.state.empresa_logada.nome_fantasia;
      },

      async buscarVendasDiaSemanaMes(tipo_visao) {
        if (tipo_visao === 'VS') {
          this.vendas_semana_total.carregando = true;
        }
        else if (tipo_visao === 'VM') {
          this.vendas_mes_total.carregando = true;
        }
        else if (tipo_visao === 'VH') {
          this.vendas_dia_total.carregando = true;
        }

        try {
          let parametros = {
            tipo_visao: tipo_visao
          }

          let retorno = await ROrcamentoBuscarVendasDiaSemanaMesDashboard.buscarVendasDiaSemanaMes(
            this.axios,
            parametros
          );

          if (tipo_visao == 'VS') {
            if (!this.vendas_semana_total.ativado) {
              this.$set(this.vendas_semana_total, 'ativado', true);
            }

            this.vendas_semana_total.vendas_liquidas = retorno.dados.totais_vendas[0].vendas_liquidas;
            this.vendas_semana_total.ticket_medio = retorno.dados.totais_vendas[0].ticket_medio;
            this.vendas_semana_total.perc_lucro = retorno.dados.totais_vendas[0].perc_lucro;
            this.vendas_semana_total.carregando = false;
          }
          else if (tipo_visao === 'VM') {
            if (!this.vendas_mes_total.ativado) {
              this.$set(this.vendas_mes_total, 'ativado', true);
            }

            this.vendas_mes_total.vendas_liquidas = retorno.dados.totais_vendas[0].vendas_liquidas;
            this.vendas_mes_total.ticket_medio = retorno.dados.totais_vendas[0].ticket_medio;
            this.vendas_mes_total.perc_lucro = retorno.dados.totais_vendas[0].perc_lucro;
            this.vendas_mes_total.carregando = false
          }
          else if (tipo_visao === 'VH') {
            this.vendas_dia_total.vendas_liquidas = retorno.dados.totais_vendas[0].vendas_liquidas;
            this.vendas_dia_total.ticket_medio = retorno.dados.totais_vendas[0].ticket_medio;
            this.vendas_dia_total.perc_lucro = retorno.dados.totais_vendas[0].perc_lucro;
            this.vendas_dia_total.carregando = false;
          }
        }
        catch (error) {
          console.log(error)
          return;
        }
      },

      async buscarInformacoesComprasEntradas(){
        try {
          if (!this.informacoes_paineis || this.informacoes_paineis.compras_entradas_vazio){
            return;
          }

          this.processando_informacoes = true;

          let parametros = {
            operacao: 'buscarComprasEntradasDashboard'
          }

          let retorno = await REntrada.buscarInformacoesComprasEntradas(
            this.axios, 
            parametros
          );
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          this.processando_informacoes = false;
          this.informacoes_compras_entradas = retorno.dados.informacoes;
        }
        catch (error) {
          console.log(error);
          return;
        }
      },

      async buscarInformacoes() {
        try {
          if (!await localStorage.getItem('paineis')) {
            this.informacoes_paineis = null;
            this.carregando_configuracoes = false;
          }

          if (!await RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
          }

          let dados_usuario = await JSON.parse(JSON.stringify(store.state.usuario_logado));
          let configuracoes = await JSON.parse(localStorage.getItem('paineis'));

          if (!configuracoes || (configuracoes.usuario_logado != dados_usuario.funcionario_id)) {
            this.carregando_configuracoes = false;
            this.informacoes_paineis = null;
            return;
          }

          this.informacoes_paineis = configuracoes;
          if 
            (
              this.informacoes_paineis.vendas.pedidos_ultimo_dia && 
              (this.autorizacoes.painel_vendas == 'S' || this.autorizacoes.usuario_gerente == 'S')
            )
          {
            await this.buscarVendasDiaSemanaMes('VH');
          }

          this.carregando_configuracoes = false;
        }
        catch (error) {
          console.log(error)
        }
      },

      strPadraoToNumber(str){
        var aux = str;
        aux = aux.split(".").join("");
        aux = aux.replace(',','.');
        return aux;
      },

      buscarQuantidadeInformacoesVendas(id) {
        for(let i = 0; i < this.informacoes_vendas.length; i++) {
          if (this.informacoes_vendas[i].informacao_id === id) {
            return this.formatarValor(this.informacoes_vendas[i].quantidade, 0);
          }
        }
      },

      buscarQuantidadeInformacoesComprasEntradas(id) {
        for (let i = 0; i < this.informacoes_compras_entradas.length; i++) {
          if (this.informacoes_compras_entradas[i].informacao_id === id) {
            return this.formatarValor(this.informacoes_compras_entradas[i].quantidade, 0);
          }
        }
      },

      buscarQuantidadeInformacoesFinanceiro(nome_saldo) {
        return '';
      },
      
      async buscarEmpresasAutorizadas() {
        try {
          if (!await RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
          }
          
          this.empresas_autorizadas = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));
          
          for (var i = 0; i < this.empresas_autorizadas.length; i++) {
            this.empresas_autorizadas[i].adicionado = true;
            this.empresas_autorizadas_id.push(this.empresas_autorizadas[i].empresa_id);
          }
        } 
        catch (error) {
          toastr.error('Erro ao buscar empresas autorizadas!', error);
        }
      },
      
      alterarVerDetalhes(item) {
        item.ver_detalhes = !item.ver_detalhes;
      },

      quantidadeProdutoPromocao(empresa) {
        this.informacoes_vendas[2].quantidade = empresa.quant_produto;
        this.informacoes_vendas[2].nome_empresa = empresa.nome_empresa;
        this.nome_empresa_promocao = empresa.nome_empresa;
      },

      quantidadeProdutoPontaEstoque(empresa) {
        this.informacoes_vendas[3].quantidade = empresa.quant_produto;
      },

      quantidadeProdutoCadastro30Dias(empresa) {
        this.informacoes_vendas[4].quantidade = empresa.quant_produto;
      },
      
      quantidadeProdutoComissaoEspecial(empresa) {
        this.informacoes_vendas[5].quantidade = empresa.quant_produto;
      },
      
      buscarClassePainel(ver_detalhes) {
        if (ver_detalhes) {
          return 'margin-left-5 texto-card-painel-selecionado';
        }
        else {
          return 'margin-left-5 texto-card-painel';
        }
      },

      async buscarContasContabeisRegraProvisionamento(exibir_nenhum_dado_encontrado) {
        try {
          this.contas_fora_regra_provisao_carregando = 1;

          let retorno = await RContaContabil.buscarContasContabeisRegraProvisionamentoDashboard(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.contas_fora_regra_provisao_carregando = 0;
          this.fora_regra_provisao = JSON.parse(JSON.stringify(retorno.dados));
          this.quantidadade_contas_contabeis_regra_provisionamento = retorno.dados.length;

          if 
            (
              exibir_nenhum_dado_encontrado && 
              (this.quantidadade_contas_contabeis_regra_provisionamento == 0)
            )
          {
            Biblioteca.exclamar('Nenhum dado foi encontrado!');
          }
        }
        catch (error) {
          this.contas_fora_regra_provisao_carregando = 0;
          toastr.error(error.message);
        }
      },

      async buscarContasContabeisSaldoDiferenteNatureza(exibir_nenhum_dado_encontrado) {
        this.contas_saldo_dif_natureza_carregando = 1;
        
        try {
          let retorno = await RContaContabil.buscarContasContabeisSaldoDiferenteNaturezaDashboard(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          
          this.contas_saldo_dif_natureza_carregando = 0;
          this.saldo_dif_natureza = JSON.parse(JSON.stringify(retorno.dados));
          this.quantidadade_contas_contabeis_saldo_diferente_natureza = retorno.dados.length;

          if 
            (
              exibir_nenhum_dado_encontrado &&
              (this.quantidadade_contas_contabeis_saldo_diferente_natureza == 0)
            )
          {
            Biblioteca.exclamar('Nenhum dado foi encontrado!');
          }
        } 
        catch (error) {
          this.contas_saldo_dif_natureza_carregando = 0;
          toastr.error(error.message);
        }
      }
    }
  }
</script>

<style scoped>
  #principal {
    padding-bottom: 20px;
  }

  .configuracoes-botao {
    text-decoration: underline;
    cursor: pointer;
  }

  .configuracoes-botao:hover {
    text-decoration: none
  }

  .text-center {
    text-align: center;
  }

  .configuracoes-mapa-financeiro {
    text-align: left;
  }

  .tablink:hover {
    color: #000!important;
    background-color: #ccc!important;
  }

  .tablink {
    cursor: pointer
  }

  .card-dashboard {
    border-radius: 10px;
    float: left;
    width: calc((100% / 4) - 15px);
    margin: 0 auto;
    background-color: #e6e6e6;
    padding: 5px;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    display: table;
    text-align: center;
  }

  .card-dashboard-escondido {
    display: none !important;
  }

  .card-clicavel-titulo {
    text-decoration: underline
  }

  .card-dashboard.card-dashboard-ativo .w3-display-topright i,
  .card-dashboard.card-dashboard-ativo .card-dashboard-titulo,
  .card-dashboard.card-dashboard-ativo .card-dashboard-dado {
    color: white !important;
  }

  .card-dashboard.card-dashboard-ativo .card-dashboard-inner .icone-card {
    color: white;
    border: 2px solid white;
  }

  .card-dashboard .card-dashboard-inner {
    display: table-cell;
    position: relative;
    height: 135px;
    padding-top: 10px;
  }
  
  .card-dashboard-ativo .card-dashboard-inner {
    display: table-cell;
    position: relative;
    height: 75px;
    padding-top: 1px;
  }

  .card-dashboard .card-dashboard-inner .icone-card {
    color: #9c1d1c;
    display: inline-block;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    border: 2px solid #9c1d1c;
    margin-bottom: 15px;
    line-height: 44px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 2em;
  }

  .card-dashboard .card-dashboard-inner .w3-right-align {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  @media(max-width: 1700px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 1085px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 845px) {
    .card-dashboard {
      width: calc((100%/2) - 15px)
    }
  }

  @media(max-width: 645px) {
    .card-dashboard,.card-dashboard .w3-right-align {
      width: 100%;
      margin-right: 0 !important;
      text-align: center;
    }

    .card-dashboard-titulo {
      font-size: 16px !important;
    }

    .card-dashboard .w3-right-align {
      text-align: center !important;
      min-width: 235px !important
    }


    .card-dashboard .card-dashboard-inner span b {
      font-size: 12px;
      padding-bottom:10px;
    }
  }

  .card-dashboard-titulo {
    font-size: 1.2em;
    color: #666;
    width: 60%;
    display: inline-block;
    text-align: center;
  }

  .card-dashboard-dado {
    font-size: 16px;
    font-weight: bold;
    color: #9c1d1c;
  }

  .card-dashboard-dado.reduzido {
    font-size: 1.4em !important;
  }

  .texto-reduzido {
    font-size: 1.5em !important;
  }
  .card-pedidos {
    font-size: 0.9em !important;
    font-weight: 400
  }
  .container-pedidos {
    text-align: left !important;
    white-space: nowrap;
  }
  .titulo-pedidos {
    font-size: 1em !important;
  }
  .atualizar-button-pedidos {
    border-radius: 50% !important;
    z-index: 30 !important;
    position: relative;
    width: 55px;
    height: 55px;

  }
  .alert-card-atualizacao {
    color: #9c1d1c;
    font-size: 14px;
    font-weight: bold;
    white-space: normal;
    text-align: center
  }
  
  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
  
  .contas-contabeis-regras-provisionamento .card-dashboard-ativo button,
  .contas-contabeis-saldo-diferente-natureza .card-dashboard-ativo button{
    color: #9c1d1c !important;
    background-color: #fff !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue